'use strict'

document.addEventListener('DOMContentLoaded', () => {
  /********************************
   * Vars
   *******************************/
  const html = document.querySelector('html');
  const body = document.querySelector('body');
  const screenWidth = window.innerWidth;

  /********************************
   * Klaviyo Form
   *******************************/
  const klaviyoFormGroup = document.querySelectorAll('.klaviyo-form');

  if (klaviyoFormGroup.length) {
    function submitKlaviyoForm(e, listId, companyId, klaviyoForm, klaviyoFormError, klaviyoFormSuccessful) {
      e.preventDefault();
      const emailInput = klaviyoForm.querySelector('.input-email');
      if (!emailInput.value) return;

      fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + companyId, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'revision': '2024-07-15'
        },
        body: JSON.stringify({
          data: {
            type: "subscription",
            attributes: {
              profile: {
                data: {
                  type: "profile",
                  attributes: {
                    email: emailInput.value,
                  }
                }
              }
            },
            relationships: {
              list: {
                data: {
                  type: "list",
                  id: listId
                }
              }
            }
          }
        })
      })

      .then(function (response) {
        return response.text();
      })
      .then(function (data) {
        console.log(`data, ${data}`);
        emailInput.value = '';
        klaviyoFormSuccessful.style.display = 'block'
      })
      .catch(function (error) {
        console.error('Error:', error);
        klaviyoFormError.style.display = 'block'
      });
    }

    klaviyoFormGroup.forEach(klaviyoFormItem => {
      const listId = klaviyoFormItem.dataset.list;
      const companyId = klaviyoFormItem.dataset.companyId;
      const klaviyoForm = klaviyoFormItem.querySelector('form');
      const klaviyoFormError = klaviyoFormItem.querySelector('.subscribe-error');
      const klaviyoFormSuccessful = klaviyoFormItem.querySelector('.subscribe-successful');

      klaviyoForm.addEventListener('submit', (e) => submitKlaviyoForm(e, listId, companyId, klaviyoForm, klaviyoFormError, klaviyoFormSuccessful));
    });
  }

  /********************************
   * Header animation
   *******************************/
  const header = document.querySelector('.section-header');

  if (header) {
    const desktopMedia = window.matchMedia('(min-width: 992px)');

    let cleanupDesktop = null;
    let cleanupMobile = null;

    function waitTransition(element, propertyName, timeout = 500) {
      return new Promise((resolve) => {
        let resolved = false;

        const done = () => {
          if (resolved) return;
          resolved = true;
          element.removeEventListener('transitionend', onEnd);
          resolve();
        };

        const onEnd = (event) => {
          if (event.target === element && event.propertyName === propertyName) {
            done();
          }
        };

        element.addEventListener('transitionend', onEnd);
        setTimeout(done, timeout);
      });
    }

    function initStickyHeader() {
      const toggleSticky = () => {
        if (window.scrollY > 0) {
          header.classList.add('sticky');
        } else {
          header.classList.remove('sticky');
        }
      };

      toggleSticky();
      window.addEventListener('scroll', toggleSticky, { passive: true });

      return () => {
        window.removeEventListener('scroll', toggleSticky);
      };
    }

    function initDesktopMenu() {
      const headerLayout = header.querySelector('.header-layout');
      const dropdownItems = [...header.querySelectorAll('.parent-li')];

      if (!headerLayout || !dropdownItems.length) return () => {};

      let isOpen = false;
      let closeTimeout = null;
      let animationToken = 0;
      let activeItem = null;
      let desiredItem = null;

      function clearItemState(item) {
        if (!item) return;

        item.classList.remove(
            'is-dropdown-visible',
            'is-dropdown-content-visible',
            'is-closing',
            'active'
        );
      }

      function clearAllItems(exceptItem = null) {
        dropdownItems.forEach((item) => {
          if (item !== exceptItem) {
            clearItemState(item);
          }
        });
      }

      function getExpandedWidth() {
        const currentScreenWidth = body.clientWidth;
        const sideOffset = currentScreenWidth >= 1392 ? 80 : 32;

        return Math.ceil(currentScreenWidth - sideOffset);
      }

      function getCollapsedWidth() {
        const previousWidth = headerLayout.style.width;
        const previousTransition = headerLayout.style.transition;

        headerLayout.style.transition = 'none';
        headerLayout.style.width = 'fit-content';

        const width = Math.ceil(headerLayout.getBoundingClientRect().width);

        headerLayout.style.width = previousWidth;
        headerLayout.style.transition = previousTransition;
        headerLayout.offsetWidth;

        return width;
      }

      function setFixedCurrentWidth() {
        const currentWidth = Math.ceil(headerLayout.getBoundingClientRect().width);
        headerLayout.style.width = `${currentWidth}px`;
        headerLayout.offsetWidth;

        return currentWidth;
      }

      function shouldCollapseHeader() {
        return (
            isOpen ||
            header.classList.contains('is-animating') ||
            header.classList.contains('is-open') ||
            (headerLayout.style.width && headerLayout.style.width !== 'fit-content')
        );
      }

      async function expandHeader(token) {
        const expandedWidth = getExpandedWidth();

        setFixedCurrentWidth();
        header.classList.add('is-animating');
        header.classList.remove('is-open');
        headerLayout.style.width = `${expandedWidth}px`;

        await waitTransition(headerLayout, 'width', 600);

        if (token !== animationToken) return false;

        header.classList.remove('is-animating');
        header.classList.add('is-open');
        isOpen = true;

        return true;
      }

      async function collapseHeader(token) {
        const collapsedWidth = getCollapsedWidth();

        setFixedCurrentWidth();
        header.classList.remove('is-open');
        header.classList.add('is-animating');
        headerLayout.style.width = `${collapsedWidth}px`;

        await waitTransition(headerLayout, 'width', 600);

        if (token !== animationToken) return false;

        header.classList.remove('is-animating');
        headerLayout.style.width = 'fit-content';
        isOpen = false;

        return true;
      }

      async function showItem(item, token) {
        if (!item || token !== animationToken) return;

        clearAllItems(item);

        item.classList.remove('is-closing');
        item.classList.add('is-dropdown-visible');

        await new Promise((resolve) => requestAnimationFrame(resolve));
        if (token !== animationToken || desiredItem !== item) return;

        item.classList.add('is-dropdown-content-visible');
        activeItem = item;
      }

      async function hideActiveItem(token) {
        if (!activeItem) return true;

        const item = activeItem;

        item.classList.add('is-closing');
        item.classList.remove('is-dropdown-content-visible');

        await new Promise((resolve) => setTimeout(resolve, 180));
        if (token !== animationToken) return false;

        if (desiredItem) {
          item.classList.remove('is-closing');
          return false;
        }

        item.classList.remove('is-dropdown-visible');

        await new Promise((resolve) => setTimeout(resolve, 180));
        if (token !== animationToken) return false;

        item.classList.remove('is-closing');

        if (activeItem === item) {
          activeItem = null;
        }

        return true;
      }

      async function syncMenuState() {
        const token = ++animationToken;
        clearTimeout(closeTimeout);

        if (desiredItem) {
          if (!isOpen) {
            const expanded = await expandHeader(token);
            if (!expanded || token !== animationToken || !desiredItem) return;
          } else {
            const expandedWidth = getExpandedWidth();
            header.classList.add('is-open');
            header.classList.remove('is-animating');
            headerLayout.style.width = `${expandedWidth}px`;
          }

          if (token !== animationToken || !desiredItem) return;

          await showItem(desiredItem, token);
          return;
        }

        const hidden = await hideActiveItem(token);
        if (!hidden && desiredItem) return;
        if (token !== animationToken) return;

        if (shouldCollapseHeader()) {
          await collapseHeader(token);
        }
      }

      function scheduleClose() {
        clearTimeout(closeTimeout);
        closeTimeout = setTimeout(() => {
          desiredItem = null;
          syncMenuState();
        }, 60);
      }

      function cancelClose() {
        clearTimeout(closeTimeout);
      }

      const listeners = [];

      dropdownItems.forEach((item) => {
        const dropdown = item.querySelector('.dropdown-wrap');
        if (!dropdown) return;

        const onItemEnter = () => {
          cancelClose();
          desiredItem = item;
          syncMenuState();
        };

        const onItemLeave = (event) => {
          if (item.contains(event.relatedTarget)) return;
          scheduleClose();
        };

        const onDropdownEnter = () => {
          cancelClose();
          desiredItem = item;
          syncMenuState();
        };

        const onDropdownLeave = (event) => {
          if (item.contains(event.relatedTarget)) return;
          scheduleClose();
        };

        item.addEventListener('mouseenter', onItemEnter);
        item.addEventListener('mouseleave', onItemLeave);
        dropdown.addEventListener('mouseenter', onDropdownEnter);
        dropdown.addEventListener('mouseleave', onDropdownLeave);

        listeners.push(() => {
          item.removeEventListener('mouseenter', onItemEnter);
          item.removeEventListener('mouseleave', onItemLeave);
          dropdown.removeEventListener('mouseenter', onDropdownEnter);
          dropdown.removeEventListener('mouseleave', onDropdownLeave);
        });
      });

      const onHeaderLeave = () => {
        desiredItem = null;
        syncMenuState();
      };

      header.addEventListener('mouseleave', onHeaderLeave);

      const onResize = () => {
        if (!desktopMedia.matches) return;

        if (shouldCollapseHeader() && desiredItem) {
          headerLayout.style.width = `${getExpandedWidth()}px`;
        } else {
          headerLayout.style.width = 'fit-content';
        }
      };

      window.addEventListener('resize', onResize);

      return () => {
        clearTimeout(closeTimeout);
        window.removeEventListener('resize', onResize);
        header.removeEventListener('mouseleave', onHeaderLeave);

        listeners.forEach((removeListener) => removeListener());

        clearAllItems();
        header.classList.remove('is-animating', 'is-open');
        headerLayout.style.width = 'fit-content';

        isOpen = false;
        activeItem = null;
        desiredItem = null;
        animationToken = 0;
      };
    }

    function initMobileMenu() {
      const menuTrigger = header.querySelector('#trigger-mobile-menu');
      if (!menuTrigger) return () => {};

      const onClickTrigger = (event) => {
        event.stopPropagation();
        body.classList.toggle('show-mobile-menu');
      };

      const onDocumentClick = (event) => {
        if (window.innerWidth > 991) return;

        const isClickInsideHeader = header.contains(event.target);

        if (!isClickInsideHeader && body.classList.contains('show-mobile-menu')) {
          body.classList.remove('show-mobile-menu');
        }
      };

      menuTrigger.addEventListener('click', onClickTrigger);
      document.addEventListener('click', onDocumentClick);

      return () => {
        menuTrigger.removeEventListener('click', onClickTrigger);
        document.removeEventListener('click', onDocumentClick);
        body.classList.remove('show-mobile-menu');
      };
    }

    function setupHeaderMode() {
      if (cleanupDesktop) cleanupDesktop();
      if (cleanupMobile) cleanupMobile();

      if (desktopMedia.matches) {
        cleanupDesktop = initDesktopMenu();
        cleanupMobile = null;
      } else {
        cleanupMobile = initMobileMenu();
        cleanupDesktop = null;
      }
    }

    initStickyHeader();
    setupHeaderMode();

    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', setupHeaderMode);
    } else {
      desktopMedia.addListener(setupHeaderMode);
    }
  }

  /********************************
   * Accordion
   *******************************/
  const accordionGroups = document.querySelectorAll('.accordion-wrap');

  if (accordionGroups.length > 0) {
    accordionGroups.forEach(accordion => {
      const isAccordionActive = () => {
        const isMenu = accordion.classList.contains('header-main-navigation');
        const isMobile = window.innerWidth <= 991;
        return isMenu ? isMobile : true;
      };

      const initAccordions = () => {
        if (!isAccordionActive()) return;

        if (accordion.classList.contains('open-first-child')) {
          setTimeout(() => {
            const firstItem = accordion.querySelector('.accordion-item');
            if (firstItem) openAccordionItem(firstItem);
          }, 1300);
        }

        if (accordion.classList.contains('open-all-child')) {
          setTimeout(() => {
            const allItems = accordion.querySelectorAll('.accordion-item');
            allItems.forEach(item => openAccordionItem(item));
          }, 1300);
        }
      };

      const openAccordionItem = (item) => {
        const content = item.querySelector('.accordion-description');
        const inner = item.querySelector('.accordion-inner-content');
        const padding = +item.dataset.descriptionPadding || 12;

        item.classList.add('active');
        content.style.height = (inner.scrollHeight + padding) + "px";
      };

      const closeAccordionItem = (item) => {
        const content = item.querySelector('.accordion-description');
        item.classList.remove('active');
        content.style.height = "0px";
      };

      accordion.addEventListener('click', function (e) {
        if (!isAccordionActive()) return;

        const target = e.target;
        const accordionItem = target.closest('.accordion-item');

        if (!accordionItem || target.closest('.accordion-description')) return;

        const isActive = accordionItem.classList.contains('active');
        const activeItem = accordion.querySelector('.accordion-item.active');

        if (isActive) {
          closeAccordionItem(accordionItem);
        } else {
          if (activeItem) closeAccordionItem(activeItem);
          openAccordionItem(accordionItem);
        }
      });

      window.addEventListener('resize', () => {
        if (accordion.classList.contains('header-main-navigation') && window.innerWidth > 991) {
          const items = accordion.querySelectorAll('.accordion-item');
          items.forEach(item => {
            item.classList.remove('active');
            item.querySelector('.accordion-description').style.height = '';
          });
        }
      });

      initAccordions();
    });
  }

  /********************************
   * Footer
   *******************************/
  function initAnimatedFooter() {
    const footers = document.querySelectorAll('.section-footer');
    if (!footers.length) return;

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const updateFooterState = () => {
      const doc = document.documentElement;
      const scrollBottom = window.scrollY + window.innerHeight;
      const documentHeight = doc.scrollHeight;
      const distanceToEnd = Math.max(documentHeight - scrollBottom, 0);

      footers.forEach((footer) => {
        const styles = getComputedStyle(footer);
        const sideGapBase = parseFloat(styles.getPropertyValue('--footer-side-gap-base')) || 16;
        const bottomSpaceBase = parseFloat(styles.getPropertyValue('--footer-bottom-space-base')) || 24;
        const radiusBase = 24;

        const triggerDistance = Math.max(window.innerHeight * 0.35, 180);
        const progress = clamp(1 - distanceToEnd / triggerDistance, 0, 1);

        footer.style.setProperty('--footer-current-gap', `${sideGapBase * (1 - progress)}px`);
        footer.style.setProperty('--footer-current-radius', `${radiusBase * (1 - progress)}px`);
        footer.style.setProperty('--footer-current-bottom-space', `${bottomSpaceBase * (1 - progress)}px`);
      });
    };

    updateFooterState();

    window.addEventListener('scroll', updateFooterState, { passive: true });
    window.addEventListener('resize', updateFooterState);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAnimatedFooter);
  } else {
    initAnimatedFooter();
  }

  /********************************
   * Section Hero banner
   *******************************/
  const sectionHeroBanner = document.querySelectorAll('.hero-banner');

  if (sectionHeroBanner.length) {
    function manageSlideVideo(swiper) {
      const allVideos = swiper.el.querySelectorAll('video');

      allVideos.forEach(video => {
        video.pause();
      });

      const activeSlide = swiper.slides[swiper.activeIndex];
      const activeVideos = activeSlide.querySelectorAll('video');

      activeVideos.forEach(video => {
        video.play().catch(error => {
          console.warn("Video play failed:", error);
        });
      });
    }

    function startSlider(sliderInit) {
      const autoplayEnabled = sliderInit.dataset.autoplay === 'true';
      const autoplayDelay   = parseInt(sliderInit.dataset.autoplayDelay, 10) || 5000;

      const swiperInstance = new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1,
        spaceBetween: 0,
        effect: "fade",
        speed: 3000,
        loop: autoplayEnabled,

        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },

        ...(autoplayEnabled ? {
          autoplay: {
            delay: autoplayDelay,
            disableOnInteraction: false,
            pauseOnMouseEnter: false,
          }
        } : {}),

        on: {
          init: function () {
            manageSlideVideo(this);
          },
          slideChange: function () {
            manageSlideVideo(this);
          }
        }
      });

      if (autoplayEnabled && swiperInstance.autoplay) {
        const actionButtons = sliderInit.querySelectorAll('.banner-button');

        actionButtons.forEach(button => {
          button.addEventListener('mouseenter', () => {
            swiperInstance.autoplay.stop();
          });

          button.addEventListener('mouseleave', () => {
            swiperInstance.autoplay.start();
          });

          const preventSwiperAction = (e) => {
            e.stopPropagation();
          };

          button.addEventListener('click', preventSwiperAction);
          button.addEventListener('mousedown', preventSwiperAction);
          button.addEventListener('touchstart', preventSwiperAction, { passive: true });
          button.addEventListener('pointerdown', preventSwiperAction);
        });
      }
    }

    sectionHeroBanner.forEach(section => {
      const slider = section.querySelector('.slider_init');
      const slideCount = section.querySelectorAll('.swiper-slide').length;
      if (slideCount > 1) {
        startSlider(slider);
      } else {
        const singleVideos = section.querySelectorAll('video');
        singleVideos.forEach(v => v.play().catch(() => {}));
      }
    });
  }

  /********************************
   * Section: featured-products
   *******************************/
  const featuredProducts = document.querySelectorAll('.featured-products');

  if (featuredProducts.length) {
    function initializeSlider(slider, slideCount) {
      if (screenWidth >= 992 && slideCount > 3) {
        startSlider(slider);
      } else if (screenWidth >= 768 && screenWidth <= 991 && slideCount > 2) {
        startSlider(slider);
      } else if (screenWidth <= 767 && slideCount > 1) {
        startSlider(slider);
        slider.closest('.slider-container').classList.add('int')
      }
    }

    function startSlider(sliderInit) {
      new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1.03,
        spaceBetween: 16,

        navigation: {
          nextEl: ".slider-button-next",
          prevEl: ".slider-button-prev",
        },

        breakpoints: {
          768: {
            slidesPerView: 2,
          },
          992: {
            slidesPerView: 3,
          }
        }
      });
    }

    featuredProducts.forEach(section => {
      const slider = section.querySelector('.slider_init');
      const slideCount = section.querySelectorAll('.swiper-slide').length;

      initializeSlider(slider, slideCount)
    });
  }

  /********************************
   * Section: section-results
   *******************************/
  const sectionResults = document.querySelectorAll('.section-results');

  if (sectionResults.length) {
    function stopAllVideos(section) {
      const allVideoHolders = section.querySelectorAll('.video-holder');
      allVideoHolders.forEach(holder => {
        const video = holder.querySelector('video.background');
        const playBtn = holder.querySelector('.play-video');
        if (video && !video.paused) {
          video.pause();
          playBtn.classList.remove('active');
        }
      });
    }

    function handleVideoLogic(section) {
      const videoHolders = section.querySelectorAll('.video-holder');

      videoHolders.forEach(holder => {
        const video = holder.querySelector('video.background');
        const playBtn = holder.querySelector('.play-video');

        if (!video || !playBtn) return;

        const toggleVideo = (e) => {
          e.preventDefault();

          if (video.paused) {
            stopAllVideos(section);
            video.play();
            playBtn.classList.add('active');
          } else {
            video.pause();
            playBtn.classList.remove('active');
          }
        };

        holder.addEventListener('click', toggleVideo);
      });
    }

    function startSlider(section, sliderInit) {
      const swiperInstance = new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1.05,
        spaceBetween: 16,
        navigation: {
          nextEl: section.querySelector('.slider-button-next'),
          prevEl: section.querySelector('.slider-button-prev'),
        },
        breakpoints: {
          768: { slidesPerView: 2 },
          1200: { slidesPerView: 3 }
        },
        on: {
          slideChange: () => {
            stopAllVideos(section);
          }
        }
      });
      return swiperInstance;
    }

    function initializeSlider(section, slider, slideCount) {
      const width = screenWidth;
      let isInitialized = false;

      if (width >= 1200 && slideCount > 3) {
        startSlider(section, slider);
        section.querySelector('.slider-navigation')?.classList.add('int');
        isInitialized = true;
      } else if (width >= 768 && width <= 1199 && slideCount > 2) {
        startSlider(section, slider);
        section.querySelector('.slider-navigation')?.classList.add('int');
        isInitialized = true;
      } else if (width <= 767 && slideCount > 1) {
        startSlider(section, slider);
        section.querySelector('.column-right')?.classList.add('int');
        isInitialized = true;
      }

      handleVideoLogic(section);
    }

    sectionResults.forEach(section => {
      const slider = section.querySelector('.slider_init');
      const slides = section.querySelectorAll('.swiper-slide');
      if (slider && slides.length) {
        initializeSlider(section, slider, slides.length);
      }
    });
  }

  /********************************
   * Section: how-to-sluff
   *******************************/
  const howToSections = document.querySelectorAll('.how-to-sluff');

  if (howToSections.length) {
    const stopSectionVideos = (section) => {
      const videoHolders = section.querySelectorAll('.video-holder');
      videoHolders.forEach(holder => {
        const video = holder.querySelector('video.background');
        const playBtn = holder.querySelector('.play-video');
        if (video && !video.paused) {
          video.pause();
          playBtn?.classList.remove('active');
        }
      });
    };

    const initVideoControls = (section) => {
      const videoHolders = section.querySelectorAll('.video-holder');

      videoHolders.forEach(holder => {
        const video = holder.querySelector('video.background');
        const btn = holder.querySelector('.play-video');

        if (!video || !btn) return;

        holder.addEventListener('click', (e) => {
          e.preventDefault();
          if (video.paused) {
            stopSectionVideos(section);
            video.play();
            btn.classList.add('active');
          } else {
            video.pause();
            btn.classList.remove('active');
          }
        });
      });
    };

    function startHowToSwiper(section, sliderInit) {
      new Swiper(sliderInit, {
        lazy: true,
        slidesPerView: 1.33,
        spaceBetween: 24,
        breakpoints: {
          768: { slidesPerView: 3, spaceBetween: 24 },
          992: { slidesPerView: 3, spaceBetween: 30 },
          1200: { slidesPerView: 4, spaceBetween: 40 }
        },
        on: {
          slideChange: () => stopSectionVideos(section)
        }
      });
    }

    function initializeHowToSlider(section, slider, slideCount) {
      const screenWidth = window.innerWidth;

      if (screenWidth >= 1200 && slideCount > 4) {
        startHowToSwiper(section, slider);
      } else if (screenWidth >= 768 && screenWidth <= 1199 && slideCount > 3) {
        startHowToSwiper(section, slider);
      } else if (screenWidth <= 767 && slideCount > 1) {
        startHowToSwiper(section, slider);
        slider.closest('.slider-container')?.classList.add('int');
      }

      initVideoControls(section);
    }

    howToSections.forEach(section => {
      const slider = section.querySelector('.slider_init');
      const slides = section.querySelectorAll('.swiper-slide');

      if (slider && slides.length) {
        initializeHowToSlider(section, slider, slides.length);
      }
    });
  }

  /********************************
   * Section: section-reviews
   *******************************/
  const sectionReviews = document.querySelectorAll('.section-reviews');

  if (sectionReviews.length) {
    function initializeSlider(slider, slideCount) {
      if (screenWidth >= 1200 && slideCount > 4) {
        startSlider(slider);
      } else if (screenWidth >= 768 && screenWidth <= 1199 && slideCount > 3) {
        startSlider(slider);
      } else if (screenWidth <= 767 && slideCount > 1) {
        startSlider(slider);
      }
    }

    function startSlider(sliderInit) {
      new Swiper(sliderInit, {
        slidesPerView: 1.5,
        centeredSlides: true,
        spaceBetween: 16,
        loop: true,
        autoplay: {
          delay: 2500,
          disableOnInteraction: false,
        },

        breakpoints: {
          768: {
            slidesPerView: 2.7,
            spaceBetween: 20,
          },
          992: {
            slidesPerView: 3.5,
            spaceBetween: 20,
          },
          1200: {
            slidesPerView: 3.5,
            spaceBetween: 24,
          },
          1440: {
            slidesPerView: 3.9,
            spaceBetween: 24,
          },
          1660: {
            slidesPerView: 4.6,
            spaceBetween: 24,
          }
        }
      });
    }

    sectionReviews.forEach(section => {
      const slider = section.querySelector('.slider_init');
      const slideCount = section.querySelectorAll('.swiper-slide').length;

      initializeSlider(slider, slideCount)
    });
  }

  /********************************
   * Section: Single product & Video Slider
   *******************************/
  const singleProducts = document.querySelectorAll('.single-product');

  if (singleProducts.length) {
    const stopAllVideos = (container) => {
      const videos = container.querySelectorAll('[js-big-video="video"]');
      videos.forEach(video => {
        video.pause();
        const holder = video.closest('.video-holder');
        holder?.querySelector('.play-video')?.classList.remove('active');
      });
    };

    const initVideoControls = (sliderContainer) => {
      const holders = sliderContainer.querySelectorAll('.video-holder');

      holders.forEach(holder => {
        const video = holder.querySelector('[js-big-video="video"]');
        const playBtn = holder.querySelector('[js-big-video="play"]');
        const poster = holder.querySelector('.video-poster');

        if (!video) return;

        holder.addEventListener('click', (e) => {
          e.preventDefault();
          if (video.paused) {
            stopAllVideos(sliderContainer);
            video.play();
            playBtn?.classList.add('active');
            if (poster) poster.style.display = 'none';
          } else {
            video.pause();
            playBtn?.classList.remove('active');
          }
        });
      });
    };

    const startVideoSlider = (sliderElement) => {
      return new Swiper(sliderElement, {
        slidesPerView: 2.5,
        spaceBetween: 16,
        watchSlidesProgress: true,
        breakpoints: {
          1024: {
            slidesPerView: 3.5,
            spaceBetween: 20
          }
        },
        on: {
          slideChange: () => stopAllVideos(sliderElement)
        }
      });
    };

    singleProducts.forEach(section => {
      const videoSliderBlock = section.querySelector('.video-slider');

      if (videoSliderBlock) {
        const videoSliderWrap = videoSliderBlock.querySelector('.video-slider-wrap');
        const videoSliderInit = videoSliderBlock.querySelector('.slider_video_init');
        const videoSlides = videoSliderBlock.querySelectorAll('.swiper-slide');
        const screenWidth = window.innerWidth;

        if (videoSliderInit && videoSlides.length > 0) {
          const isMobile = screenWidth < 1024;
          const isDesktop = screenWidth >= 1024;

          if (isMobile && videoSlides.length > 2) {
            videoSliderWrap?.classList.add('init-slider');
            startVideoSlider(videoSliderInit);
          } else if (isDesktop && videoSlides.length > 3) {
            startVideoSlider(videoSliderInit);
          }

          initVideoControls(videoSliderInit);
        }
      }

      const mainSlider = section.querySelector('.slider_init');
      if (mainSlider && section.querySelectorAll('.slider_init .swiper-slide').length > 1) {
        new Swiper(mainSlider, {
          loop: true,
          slidesPerView: 1,
          navigation: {
            nextEl: section.querySelector('.slider-button-next'),
            prevEl: section.querySelector('.slider-button-prev'),
          },
          pagination: { clickable: true, el: section.querySelector(".swiper-pagination") }
        });
      }
    });
  }

  /********************************
   * Single product + Sticky Product visibility
   *******************************/
  const stickyProduct = document.querySelector('.sticky-product');

  if (singleProducts.length >= 1 && stickyProduct) {
    const updateSticky = (isAnyFeaturedHalfVisible) => {
      stickyProduct.classList.toggle('show', !isAnyFeaturedHalfVisible);
    };

    const inViewMap = new Map();

    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          inViewMap.set(entry.target, entry.intersectionRatio >= 0.5);
        });

        const isAnyFeaturedHalfVisible = Array.from(inViewMap.values()).some(Boolean);
        updateSticky(isAnyFeaturedHalfVisible);
      },
      {
        threshold: 0.5,
        root: null
      }
    );

    singleProduct.forEach((section) => {
      inViewMap.set(section, false);
      io.observe(section);
    });

    updateSticky(false);
  }

  /********************************
   * scroll to Okendo section
   *******************************/
  const pdpOkendoRating = document.querySelectorAll('.pdp-okendo-rating');

  if (pdpOkendoRating.length) {
    const sectionOkendoReviews = document.querySelector('.section-okendoReviews');

    if (!sectionOkendoReviews) return;

    pdpOkendoRating.forEach(button => {
      button.addEventListener('click', () =>
          button.querySelector('.trigger-scroll').click()
      );
    });
  }

  /********************************
   * Section: Video slider
   *******************************/
  const nodeSlicerSelectors = {
    container: '[js-video-slider="container"]',
    slider: '[js-video-slider="wrapper"]',
    navigation: '[js-video-slider="navigation"]',
    prev: '[js-video-slider="prev"]',
    next: '[js-video-slider="next"]',
    soundBtn: '[js-video-slider="sound"]',
  };

  const nodeVideoPlaySelectors = {
    container: '[js-big-video="container"]',
    video: '[js-big-video="video"]',
    soundBtn: '[js-big-video="sound"]',
    playBtn: '[js-big-video="play"]',
    clickableArea: '.slide-content',
  };

  function playVideo(section) {
    const video = section.querySelector(nodeVideoPlaySelectors.video);
    const videoHolder = section.querySelector('.video-holder');
    const playBtn = section.querySelector(nodeVideoPlaySelectors.playBtn);

    if (!video || !videoHolder || !playBtn) return;

    video.play();
    video.muted = false;

    playBtn.classList.add('active');
    playBtn.classList.remove('paused');
    videoHolder.classList.remove('video-play');
  }

  function pauseVideo(section) {
    const video = section.querySelector(nodeVideoPlaySelectors.video);
    const videoHolder = section.querySelector('.video-holder');
    const playBtn = section.querySelector(nodeVideoPlaySelectors.playBtn);

    if (!video || !videoHolder || !playBtn) return;

    video.pause();

    playBtn.classList.remove('active');
    playBtn.classList.add('paused');
    videoHolder.classList.add('video-play');
  }

  function toggleVideo(section) {
    const video = section.querySelector(nodeVideoPlaySelectors.video);

    if (!video) return;

    if (video.paused) {
      playVideo(section);
    } else {
      pauseVideo(section);
    }
  }

  function pauseAllVideosInSlider(sliderEl) {
    const videoSections = sliderEl.querySelectorAll(nodeVideoPlaySelectors.container);

    videoSections.forEach((section) => {
      pauseVideo(section);
    });
  }

  function initSlider() {
    const slidersContainers = document.querySelectorAll(nodeSlicerSelectors.container);

    slidersContainers.forEach((container) => {
      const sliderEl = container.querySelector(nodeSlicerSelectors.slider);

      if (!sliderEl) return;

      const videoSlider = new Swiper(sliderEl, {
        slidesPerView: 1.27,
        spaceBetween: 24,
        loop: true,
        centeredSlides: true,
        centeredSlidesBounds: true,

        breakpoints: {
          768: {
            slidesPerView: 2.7,
          },
          992: {
            slidesPerView: 3.5,
          },
          1200: {
            slidesPerView: 3.5,
          },
          1440: {
            slidesPerView: 3.9,
          },
          1660: {
            slidesPerView: 4.6,
          },
        },

        on: {
          slideChange() {
            pauseAllVideosInSlider(sliderEl);
          },
        },
      });
    });
  }

  /********************************
   * Play video
   *******************************/
  function initVideoPlay() {
    const videosSections = document.querySelectorAll(nodeVideoPlaySelectors.container);

    videosSections.forEach((section) => {
      const video = section.querySelector(nodeVideoPlaySelectors.video);
      const playBtn = section.querySelector(nodeVideoPlaySelectors.playBtn);
      const soundBtn = section.querySelector(nodeVideoPlaySelectors.soundBtn);

      if (!video) return;

      if (soundBtn) {
        soundBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (video.muted) {
            video.muted = false;
            soundBtn.classList.add('unmuted');
          } else {
            video.muted = true;
            soundBtn.classList.remove('unmuted');
          }
        });
      }

      if (playBtn) {
        playBtn.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          toggleVideo(section);
        });
      }

      section.addEventListener('click', (event) => {
        const isPlayButton = event.target.closest(nodeVideoPlaySelectors.playBtn);
        const isSoundButton = event.target.closest(nodeVideoPlaySelectors.soundBtn);

        if (isPlayButton || isSoundButton) return;

        toggleVideo(section);
      });

      video.addEventListener('ended', () => {
        pauseVideo(section);
        video.currentTime = 0;
      });

      video.addEventListener('loadeddata', () => {
        const videoHolder = section.querySelector('.video-holder');

        if (video.paused && videoHolder) {
          videoHolder.classList.add('video-play');
        }
      });
    });
  }

  if (document.querySelector(nodeVideoPlaySelectors.container)) {
    initVideoPlay();
  }

  if (document.querySelector(nodeSlicerSelectors.container)) {
    initSlider();
  }

  /********************************
   * Section: columns-content (Slider)
   *******************************/
  const columnsContent = document.querySelectorAll('.columns-content');

  if (columnsContent.length) {
    function startSlider(sliderInit) {
      new Swiper(sliderInit, {
        slidesPerView: 1,

        navigation: {
          nextEl: ".slider-button-next",
          prevEl: ".slider-button-prev",
        },

        pagination: {
          el: ".swiper-pagination",
          clickable: true,
        },
      });
    }

    columnsContent.forEach(section => {
      const slider = section.querySelectorAll('.slider_init');

      slider.forEach(sliderContainer => {
        const slideCount = sliderContainer.querySelectorAll('.swiper-slide').length;
        if (slideCount > 1) startSlider(sliderContainer)
      })
    });
  }
});